import React, { Component } from "react";
import "./SignaturePanel.component.css";
import DropDownSelect from "../../common/form-fields/drop-down/DropDownSelect";
import Helpers from "../../common/util/Helpers";

class SignaturePanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activePanel: "front"
        }
    }

    customizePlan() {
        this.setState({
            activePanel: "back"
        });
    }

    viewFront() {
        this.setState({
            activePanel: "front"
        });
    }

    renderCoinsurance() {
        let coinsuranceOptions = [];
        this.props.policyDetails.policies.map(policy => {
                if (!coinsuranceOptions.find(ele => ele.value === policy.reimbursement * 100)) {
                    let obj = { displayName: policy.reimbursement * 100 + "%", value: policy.reimbursement * 100 }
                    coinsuranceOptions.push(obj);
                }
        });

        coinsuranceOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        const isValid = coinsuranceOptions.some(
            op => op.value === this.props.tempSelectedCoinsurance
        );

        const safeValue = isValid
            ? this.props.tempSelectedCoinsurance
            : coinsuranceOptions[0]?.value;

        if (coinsuranceOptions.length >=2) {

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="coinsurance"
                className="custom-dropdown"
                id="signature_coinsurance"
                data={coinsuranceOptions}
                onChange={this.props.handleCoinsuranceChange.bind(this)}
                initialValue={safeValue}
            />
        )
        } else if (coinsuranceOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p class="customize-single-value">{coinsuranceOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-left">
                    No coinsurance options available
                </div>
            )
        }
    }

    renderDeductible() {

        let deductibleOptions = [];
        const selectedCoinsurance = Number(this.props.tempSelectedCoinsurance);

        if (!selectedCoinsurance) return null;

        // Get all policies matching selected reimbursement
        const matchingPolicies = this.props.policyDetails.policies.filter(
            policy => policy.reimbursement * 100 === selectedCoinsurance
        );

        // Check if BOTH plan types exist for this reimbursement
        const hasSignature = matchingPolicies.some(p => p.deductible < 1500);
        const hasHighDeductible = matchingPolicies.some(p => p.deductible >= 1500);

        matchingPolicies.forEach(policy => {

            // CASE 1: If reimbursement exists in BOTH → show ALL deductibles
            if (hasSignature && hasHighDeductible) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

            // CASE 2: Only Signature available
            else if (hasSignature && policy.deductible < 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

            // CASE 3: Only High Deductible available
            else if (hasHighDeductible && policy.deductible >= 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    deductibleOptions.push({
                        displayName: "$" + policy.deductible,
                        value: policy.deductible
                    });
                }
            }

        });

        // Sort values
        deductibleOptions.sort((a, b) => a.value - b.value);

        const isValid = deductibleOptions.some(
            op => op.value === this.props.tempSelectedDeductible
        );

        const safeValue = isValid
            ? this.props.tempSelectedDeductible
            : deductibleOptions[0]?.value;

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="deductible"
                className="custom-dropdown"
                id="signature_deductible"
                data={deductibleOptions}
                onChange={this.props.handleDeductibleChange.bind(this)}
                initialValue={safeValue}
            />
        );
    }

    renderAnnualPolicyLimit() {

        let annualLimitOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (!annualLimitOptions.find(ele => ele.value === policy.annual_limit)) {

                let annualLimitDisplay =
                    policy.annual_limit?.toString().toLowerCase().includes('unlimited')
                        ? policy.annual_limit.replace(/\$/g, '').trim()
                        : `$${policy.annual_limit}`;

                let obj = {
                    displayName: annualLimitDisplay,
                    value: policy.annual_limit
                };

                annualLimitOptions.push(obj);
            }
        });

        annualLimitOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (annualLimitOptions.length >= 2) {

            return (
                <DropDownSelect
                    style={{ width: "100%", backgroundColor: "#FFF" }}
                    field="policyLimit"
                    className="custom-dropdown"
                    id="signature_AnnualPolicyLimit"
                    data={annualLimitOptions}
                    onChange={this.props.handlePolicyLimitChange.bind(this)}
                    initialValue={this.props.tempSelectedPolicyLimit}
                />
            )
        } else if (annualLimitOptions.length === 1) {
            return (
                <div className="text-left single-deductible-text">
                    <p class="customize-single-value">{annualLimitOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-center">
                    No Maximum Annual Payout options available
                </div>
            )
        }
    }

    isValidPolicyCombination() {
        const selectedCoinsurance = Number(this.props.tempSelectedCoinsurance);
        const selectedDeductible = Number(this.props.tempSelectedDeductible);
        const selectedPolicyLimit = this.props.tempSelectedPolicyLimit;

        return this.props.policyDetails.policies.some(policy =>
            policy.reimbursement * 100 === selectedCoinsurance &&
            policy.deductible === selectedDeductible &&
            policy.annual_limit === selectedPolicyLimit
        );

    }

    getPolicyLimitTooltipMessage() {
        const { tempSelectedCoinsurance, tempSelectedDeductible } = this.props;
        return `${tempSelectedCoinsurance}% Reimbursement is not available when choosing an Annual Deductible of $${tempSelectedDeductible}.`;
    }

    selectPlanType() {
        this.props.setSelectedPlanType("signature");
        this.viewFront();
    }


    render() {
        return (
            <div className="signature-panel mb-4">
                { this.state.activePanel === "front" && 
                    <div id="signaturePanelFront">
                        <article className="plan-card" aria-label="Signature Insurance Plan">

                            {/* LEFT SECTION */}
                            <div className="plan-left">

                                <div className="plan-heading">
                                    <span className="check-icon" aria-hidden="true">
                                    </span>

                                    <h2 className="plan-title">Signature Plan</h2>

                                </div>

                                <p className="plan-subtitle">
                                    Comprehensive, customizable coverage
                                    <br />
                                    for accidents & illness
                                </p>

                                <p className="plan-description">
                                    Coverage for accidents and illnesses,
                                    <br />
                                    designed for life's daily adventures and the
                                    <br />
                                    surprises you can't foresee.
                                </p>

                            </div>

                            {/* RIGHT SECTION */}
                            <div className="plan-right">

                                <div className="plan-price">
                                    <span className="price">
                                        {Helpers.formatCurrency(
                                            (this.props.selectedPremium || "0").toString().replace(',', '')
                                        )}
                                    </span>
                                    <span className="per-month">/mo.</span>
                                    {/*<span className="price">{Helpers.formatCurrency(this.props.selectedPremium.replace(',', ''))}</span><span class="per-month">/mo.</span>*/}
                                </div>
                                <div className="plan-info">

                                    <div className="plan-row">
                                        <span className="text-normal">Maximum Annual Payout</span>
                                        <span className="text-bold">
                                            {
                                                this.props.tempSelectedPolicyLimit?.toString().toLowerCase().includes('unlimited')
                                                    ? this.props.tempSelectedPolicyLimit.replace(/\$/g, '').trim()
                                                    : `$${this.props.tempSelectedPolicyLimit}`
                                            }
                                        </span>
                                    </div>

                                    <div className="plan-row">
                                        <span className="text-normal">Reimbursement</span>
                                        <span className="text-bold">{this.props.selectedCoinsurance}%</span>
                                    </div>

                                    <div className="plan-row">
                                        <span className="text-normal">Annual Deductible</span>
                                        <span className="text-bold">${this.props.selectedDeductible}</span>
                                    </div>

                                </div>

                                <button onClick={this.customizePlan.bind(this)}
                                    className="plan-button"
                                    aria-label="Customize Signature Plan">
                                    Customize Plan
                                </button>
                                {this.props.selectedPlanType !== "signature" ?
                                    
                                    (<div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right">Select This Plan</div>) :""
                                }

                            </div>
                            <div className="clear-both"></div>
                        </article>

                        
                    {/*<div className="col text-center py-4 px-3 signature-panel-front-content">*/}
                    {/*    <h3 className="text-center font-weight-bold signature-panel-front-title">Signature Plan 1</h3>*/}
                    {/*    <p className="text-center signature-panel-front-description">*/}
                    {/*    Coverage for accidents and illnesses, designed for life’s daily adventures and the surprises you can’t foresee. <span className="font-weight-bold">Lower deductibles mean payouts start sooner</span>.*/}
                    {/*    </p>*/}
                    {/*    <div className="d-block px-3 py-2 signature-panel-front-table">*/}
                    {/*        <span className="font-weight-bold signature-panel-front-table-title">{Helpers.formatCurrency(this.props.selectedPremium.replace(',', ''))}</span>/month*/}
                    {/*        <table className="text-start signature-panel-front-table-content">*/}
                    {/*            <tr>*/}
                    {/*                <td>Reimbursement:</td>*/}
                    {/*                <td><span className="font-weight-bold">{this.props.selectedCoinsurance}%</span></td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td>Annual Deductible:</td>*/}
                    {/*                <td><span className="font-weight-bold">${this.props.selectedDeductible}</span></td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td>Maximum Payouts:</td>*/}
                    {/*                <td><span className="font-weight-bold">Unlimited</span></td>*/}
                    {/*            </tr>*/}
                    {/*        </table>*/}
                            
                    {/*        <div className="text-start">*/}
                    {/*            <a type="button" class="text-start font-weight-bold signature-panel-front-table-link">What do these terms mean?</a>*/}
                    {/*        </div>*/}
                            
                    {/*    </div>*/}
                    {/*    <div className="mt-3 signature-panel-front-table-content">*/}
                    {/*            <a type="button" onClick={this.customizePlan.bind(this)} className="float-left buttonlink align-middle position-relative customize-plan" style={{ paddingLeft :"2px", textDecoration :"underline" , marginTop:"10px" }}>Customize Plan</a>*/}
                    {/*        { this.props.selectedPlanType === "signature" ? */}
                    {/*            (<button type="button" className="button-primary align-middle float-right button-plan-selected">Selected <img src="/assets/images/check-mark-white.png" className="ml-1 check-mark-white" /></button>) :*/}
                    {/*            (<div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right">Select This Plan</div>)*/}
                    {/*        }*/}
                    {/*        <div className="clear-both"></div>*/}
                    {/*    </div>*/}
                        {/*</div>*/}


                </div> }
                {this.state.activePanel === "back" && 

                    <div id="signaturePanelBack" className="">
                        <div className="plan-container">
                            <div className="plan-header">
                                <div>
                                    <h2 className="plan-title">Customize the Signature Plan</h2>
                                    <p>Available options may change based off your chosen ranges.</p>
                                </div>
                                <span className="close-btn" onClick={this.viewFront.bind(this)}>✕</span>
                            </div>

                            <div className="plan-grid">

                                <div className="form-group">
                                    <label>Maximum Annual Payout</label>
                                    {
                                        this.renderAnnualPolicyLimit()
                                    }
                                </div><div class="form-group">
                                <div className="label-with-tooltip">
                                    <label>Reimbursement</label>
                                    </div>
                                    {this.renderCoinsurance() }
                                </div>
                                
                                <div className="form-group">
                                    <label>Annual Deductible</label>
                                    {
                                        this.renderDeductible()
                                    }
                                </div>

                                <div className="form-group margin-bottom-override">
                                    <div className="plan-footer">
                                        <div className="price">
                                            {Helpers.formatCurrency(
                                                (this.props.tempSelectedPremium || "0").toString().replace(',', '')
                                            )}<span>/mo.</span>
                                        </div>

                                        <button
                                            className="save-btn"
                                            onClick={this.selectPlanType.bind(this)}
                                        >
                                            Save
                                        </button>

                                    </div>
                                </div> 

                            </div>

                           
                        </div>
                   
                </div> }
               
            </div>
        )
    }
}



export default SignaturePanel;